var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAnyType, FctBoolean, FctRadio, FctString } from '../../../Fct/generics';
var indexes = ['1', '2', '3', '4', '5'];
var indexOptions = indexes.map(function (index) { return ({
    name: "value".concat(index),
    value: index,
}); });
var MAX_PARAMS_AMOUNT = indexes.length;
export var Reflow = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'reflow',
    name: 'reflow',
    flowType: 'OFFCHAIN_ONLY',
    initParams: {
        in: 'connection',
        keyIndex: undefined,
        value1: 'true',
        value2: 'false',
        value3: 'false',
        value4: 'false',
        value5: 'false',
    },
    getParams: function () { return ({
        input: {
            in: new FctString({ mode: 'INPUT', destination: 'in' }),
            keyIndex: new FctAnyType({ required: false, options: __spreadArray([{ value: undefined, name: 'custom' }], __read(indexOptions), false) }),
            key1: new FctString({ mode: 'INPUT' }),
            value1: new FctRadio({ mode: 'INPUT' }),
            key2: new FctString({ mode: 'INPUT', hidden: true }),
            value2: new FctRadio({ mode: 'INPUT', hidden: true }),
            key3: new FctString({ mode: 'INPUT', hidden: true }),
            value3: new FctRadio({ mode: 'INPUT', hidden: true }),
            key4: new FctString({ mode: 'INPUT', hidden: true }),
            value4: new FctRadio({ mode: 'INPUT', hidden: true }),
            key5: new FctString({ mode: 'INPUT', hidden: true }),
            value5: new FctRadio({ mode: 'INPUT', hidden: true }),
            methodParams: {},
        },
        output: {
            out1: new FctBoolean({ readonly: true, destination: 'out' }),
            out2: new FctBoolean({ readonly: true, hidden: true, destination: 'out' }),
            out3: new FctBoolean({ readonly: true, hidden: true, destination: 'out' }),
            out4: new FctBoolean({ readonly: true, hidden: true, destination: 'out' }),
            out5: new FctBoolean({ readonly: true, hidden: true, destination: 'out' }),
        },
    }); },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output;
        var setFlow = function (_a) {
            var changedParamKey = _a.changedParamKey;
            return __awaiter(void 0, void 0, void 0, function () {
                var keyIndex, i, paramIndex, paramValueKey, i, paramIndex, paramValueKey, k, paramIndex_1, paramValueKey_1, getParamValue, flow, i, prevIndex, paramIndex, currentKeyParam, currentValueParam, prevKeyParam, data, i, paramIndex, valueParamLabel, param;
                return __generator(this, function (_b) {
                    console.log({ changedParamKey: changedParamKey });
                    keyIndex = input.keyIndex.value;
                    if (keyIndex && typeof keyIndex === 'string' && indexes.includes(keyIndex)) {
                        for (i = 0; i < MAX_PARAMS_AMOUNT; i++) {
                            paramIndex = String(i + 1);
                            paramValueKey = "value".concat(paramIndex);
                            if (paramIndex === keyIndex) {
                                if (input[paramValueKey].value !== 'true')
                                    input[paramValueKey].value = 'true';
                            }
                            else {
                                if (input[paramValueKey].value !== 'false')
                                    input[paramValueKey].value = 'false';
                            }
                        }
                    }
                    else {
                        for (i = 0; i < MAX_PARAMS_AMOUNT; i++) {
                            paramIndex = String(i + 1);
                            paramValueKey = "value".concat(paramIndex);
                            if (changedParamKey !== paramValueKey)
                                continue;
                            if (input[paramValueKey].value !== 'true')
                                return [2 /*return*/];
                            for (k = 0; k < MAX_PARAMS_AMOUNT; k++) {
                                paramIndex_1 = String(k + 1);
                                paramValueKey_1 = "value".concat(paramIndex_1);
                                if (paramValueKey_1 === changedParamKey)
                                    continue;
                                input[paramValueKey_1].value = 'false';
                            }
                        }
                    }
                    getParamValue = function (param) {
                        if (param.isVariable)
                            return param.estimatedValue;
                        return param.value;
                    };
                    flow = [];
                    for (i = 0; i < MAX_PARAMS_AMOUNT; i++) {
                        prevIndex = String(i);
                        paramIndex = String(i + 1);
                        currentKeyParam = input["key".concat(paramIndex)];
                        currentValueParam = input["value".concat(paramIndex)];
                        if (i > 0) {
                            prevKeyParam = input["key".concat(prevIndex)];
                            if (prevKeyParam.value) {
                                currentKeyParam.hidden = false;
                                currentValueParam.hidden = false;
                            }
                            else {
                                currentKeyParam.value = undefined;
                                // currentValueParam.value = undefined
                                currentKeyParam.hidden = true;
                                currentValueParam.hidden = true;
                            }
                        }
                        if (currentKeyParam.value) {
                            flow.push({ key: getParamValue(currentKeyParam), value: getParamValue(currentValueParam) });
                        }
                    }
                    data = flow;
                    for (i = 0; i < MAX_PARAMS_AMOUNT; i++) {
                        paramIndex = String(i + 1);
                        valueParamLabel = "out".concat(paramIndex);
                        if (output[valueParamLabel]) {
                            if (data[i]) {
                                param = data[i];
                                output[valueParamLabel].hidden = false;
                                output[valueParamLabel].label = param.key || '';
                                output[valueParamLabel].value = param.value || '';
                            }
                            else {
                                output[valueParamLabel].hidden = true;
                                output[valueParamLabel].label = undefined;
                                output[valueParamLabel].value = undefined;
                            }
                        }
                    }
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                });
            });
        };
        return {
            get: setFlow,
            depParamKeys: [
                'keyIndex',
                'value1',
                'value2',
                'value3',
                'value4',
                'value5',
                'key1',
                'key2',
                'key3',
                'key4',
                'key5',
            ],
        };
    },
});
